import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAllergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAvailability from "../Restaumatic.Menu.V2.Types.Availability/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dTags from "../Restaumatic.Menu.V2.Types.Tags/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dTaxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const ModifierSettings = x => x;
const Product = x => x;
const newtypeProduct_ = {Coercible0: () => {}};
const newtypeModifierSettings_ = {Coercible0: () => {}};
const hasFieldProduct = dictHasField => dictHasField;
const hasFieldModifierSettings = dictHasField => dictHasField;
const eqModifierSettings = {
  eq: x => y => {
    const $0 = Data$dEq.eqArrayImpl(x$1 => y$1 => x$1._1 === y$1._1 && x$1._2 === y$1._2);
    return (() => {
      if (x.defaultItems.tag === "Nothing") { return y.defaultItems.tag === "Nothing"; }
      if (x.defaultItems.tag === "Just") {
        if (y.defaultItems.tag === "Just") { return $0(x.defaultItems._1)(y.defaultItems._1); }
        return false;
      }
      return false;
    })() && x.displayDefaultItems === y.displayDefaultItems && Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqBoolean).eq(x.editable)(y.editable) && x.freeItems === y.freeItems && Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqBoolean).eq(x.inputRequired)(y.inputRequired);
  }
};
const eqProduct = {
  eq: x => y => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.eqAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.eqAllergenConcentration).eq(x.allergens)(y.allergens) && (() => {
    if (x.availability.tag === "Available") { return y.availability.tag === "Available"; }
    if (x.availability.tag === "TemporarilyUnavailable") { return y.availability.tag === "TemporarilyUnavailable"; }
    if (x.availability.tag === "Hidden") { return y.availability.tag === "Hidden"; }
    return false;
  })() && (() => {
    if (x.availabilitySchedule.tag === "Nothing") { return y.availabilitySchedule.tag === "Nothing"; }
    if (x.availabilitySchedule.tag === "Just") {
      if (y.availabilitySchedule.tag === "Just") { return x.availabilitySchedule._1 === y.availabilitySchedule._1; }
      return false;
    }
    return false;
  })() && x.category === y.category && (() => {
    if (x.crossSellingListOverride.tag === "Nothing") { return y.crossSellingListOverride.tag === "Nothing"; }
    if (x.crossSellingListOverride.tag === "Just") {
      if (y.crossSellingListOverride.tag === "Just") { return x.crossSellingListOverride._1 === y.crossSellingListOverride._1; }
      return false;
    }
    return false;
  })() && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x.description)(y.description) && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.divisibleModifiersOrder)(y.divisibleModifiersOrder) && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.exchangeSuggestionList)(y.exchangeSuggestionList) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(eqModifierSettings).eq(x.modifierSettings)(y.modifierSettings) && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x.name)(y.name) && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.nonDivisibleModifiersOrder)(y.nonDivisibleModifiersOrder) && (() => {
    if (x.packagingContainersConfigOverride.tag === "Nothing") { return y.packagingContainersConfigOverride.tag === "Nothing"; }
    if (x.packagingContainersConfigOverride.tag === "Just") {
      if (y.packagingContainersConfigOverride.tag === "Just") {
        return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqPackagingContainersConf.eq(x.packagingContainersConfigOverride._1)(y.packagingContainersConfigOverride._1);
      }
      return false;
    }
    return false;
  })() && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqInt).eq(x.price)(y.price) && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.productModifiers)(y.productModifiers) && Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dTags.eqTag)(Data$dEq.eqUnit).eq(x.tags)(y.tags) && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.upSellingParameters)(y.upSellingParameters) && Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqBoolean).eq(x.variants)(y.variants) && (() => {
    if (x.vatRate.tag === "Nothing") { return y.vatRate.tag === "Nothing"; }
    if (x.vatRate.tag === "Just") {
      if (y.vatRate.tag === "Just") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })() && Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.eqMenuConsumer)(Data$dEq.eqUnit).eq(x.visibleIn)(y.visibleIn)
};
const genericProduct = {to: x => x, from: x => x};
const genericModifierSettings = {to: x => x, from: x => x};
const showModifierSettings = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showBoolean);
      const $1 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showBoolean);
      const $2 = Data$dShow.showArrayImpl(Data$dTuple$dT2.showT2(Data$dUUID.showUUID)(Data$dShow.showInt).show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "defaultItems",
              (() => {
                if (v.defaultItems.tag === "Just") { return "(Just " + $2(v.defaultItems._1) + ")"; }
                if (v.defaultItems.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["displayDefaultItems", v.displayDefaultItems ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "editable",
              $1.show(v.editable)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["freeItems", Data$dShow.showIntImpl(v.freeItems)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "inputRequired",
              $0.show(v.inputRequired)
            ]))([])))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ModifierSettings"});
    return x => $0["genericShow'"](x);
  })()
};
const showProduct = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.showMenuConsumer);
      const $1 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showBoolean);
      const $2 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $3 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dTags.showTag);
      const $4 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $5 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dMoney$dRounded.showMoney);
      const $6 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $7 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      const $8 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(showModifierSettings);
      const $9 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $10 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $11 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      const $12 = Data$dMap$dInternal.showMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.showAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.showAllergenConcentration);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["allergens", $12.show(v.allergens)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "availability",
              Restaumatic$dMenu$dV2$dTypes$dAvailability.showAvailability.show(v.availability)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "availabilitySchedule",
              (() => {
                if (v.availabilitySchedule.tag === "Just") { return "(Just " + v.availabilitySchedule._1 + ")"; }
                if (v.availabilitySchedule.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["category", v.category]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "crossSellingListOverride",
              (() => {
                if (v.crossSellingListOverride.tag === "Just") { return "(Just " + v.crossSellingListOverride._1 + ")"; }
                if (v.crossSellingListOverride.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["description", $11.show(v.description)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "divisibleModifiersOrder",
              $10(v.divisibleModifiersOrder)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["exchangeSuggestionList", $9(v.exchangeSuggestionList)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "modifierSettings",
              $8.show(v.modifierSettings)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["name", $7.show(v.name)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "nonDivisibleModifiersOrder",
              $6(v.nonDivisibleModifiersOrder)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "packagingContainersConfigOverride",
              (() => {
                if (v.packagingContainersConfigOverride.tag === "Just") {
                  return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainersConfig.show(v.packagingContainersConfigOverride._1) + ")";
                }
                if (v.packagingContainersConfigOverride.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "photo",
              (() => {
                if (v.photo.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v.photo._1) + ")"; }
                if (v.photo.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["price", $5.show(v.price)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["productModifiers", $4(v.productModifiers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "tags",
              $3.show(v.tags)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["upSellingParameters", $2(v.upSellingParameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "variants",
              $1.show(v.variants)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "vatRate",
              (() => {
                if (v.vatRate.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dTaxes.showVatRate.show(v.vatRate._1) + ")"; }
                if (v.vatRate.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["visibleIn", $0.show(v.visibleIn)]))([]))))))))))))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "Product"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeModifierSettings = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "defaultItems"})(Unscramble.decodeMaybe({
      unsafeDecode: Unscramble.decodeArray(Data$dTuple$dT2.udecodeT2(Data$dUUID.udecodeUUID)(Unscramble.decodeInt1).unsafeDecode)
    }))(Unscramble.decodeRecordCons({reflectSymbol: () => "displayDefaultItems"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "editable"})(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "freeItems"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({reflectSymbol: () => "inputRequired"})(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeProduct = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "allergens"})(Unscramble.decodeMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.ufromJSONKeyAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.unscrambleDecodeAllergenConcentration))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "availability"
    })(Restaumatic$dMenu$dV2$dTypes$dAvailability.unscrambleDecodeAvailability)(Unscramble.decodeRecordCons({reflectSymbol: () => "availabilitySchedule"})(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "category"
    })(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordCons({reflectSymbol: () => "crossSellingListOverride"})(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "description"
    })(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "divisibleModifiersOrder"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "exchangeSuggestionList"})({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "modifierSettings"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(unscrambleDecodeModifierSettings))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "name"
    })(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "nonDivisibleModifiersOrder"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "packagingContainersConfigOverride"})(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodePackagingContainersConfig))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "photo"
    })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto))(Unscramble.decodeRecordCons({reflectSymbol: () => "price"})(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Data$dMoney$dRounded.udecodeMoney))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "productModifiers"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "tags"})(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dTags.unscrambleDecodeTag)(Restaumatic$dMenu$dV2$dTypes$dTags.ordTag))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "upSellingParameters"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "variants"})(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "vatRate"
    })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dTaxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordCons({reflectSymbol: () => "visibleIn"})(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer))(Unscramble.decodeRecordNil)))))))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeModifierSettings = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericModifierSettings)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ModifierSettings"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "inputRequired"
    })((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.booleanEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "freeItems"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "editable"})((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.booleanEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "displayDefaultItems"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "defaultItems"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dTuple$dT2.encodeT2({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}).encode);
      return {
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return $0(v2._1); }
          $runtime.fail();
        }
      };
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeProduct = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProduct)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Product"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "visibleIn"
    })((() => {
      const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.encodeMenuConsumer);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "vatRate"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dTaxes.encodeVatRate.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "variants"})((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.booleanEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "upSellingParameters"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "tags"})((() => {
      const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dTags.encodeTag);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "productModifiers"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "price"})((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Data$dMoney$dRounded.encodeMoney)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", Data$dInt.toNumber(v) / 100.0), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "photo"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPhoto.encodePhoto.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "packagingContainersConfigOverride"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainersConfig.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "nonDivisibleModifiersOrder"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "name"})((() => {
      const $0 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "modifierSettings"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(encodeModifierSettings)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeModifierSettings.encode(v)), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "exchangeSuggestionList"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "divisibleModifiersOrder"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "description"})((() => {
      const $0 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "crossSellingListOverride"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "category"})({encodeWithOptions: v => Data$dUUID.encodeUUID.encode}))({reflectSymbol: () => "availabilitySchedule"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "availability"})({encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.encodeAvailability.encode}))({reflectSymbol: () => "allergens"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.asJSONKeyAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.encodeAllergenConcentration)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg(
            "PlainArg",
            (() => {
              if (v.tag === "TraceConcentration") { return "TraceConcentration"; }
              if (v.tag === "HighConcentration") { return "HighConcentration"; }
              $runtime.fail();
            })()
          ),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeModifierSettings = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericModifierSettings)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ModifierSettings"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "inputRequired"
  })(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.booleanDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "freeItems"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "editable"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.booleanDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "displayDefaultItems"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "defaultItems"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.arrayDecode(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)}), decodeSingleRecordArg: Data$dMaybe.Nothing})).decode);
    return {decodeWithOptions: v => $0};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeProduct = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProduct)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Product"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "visibleIn"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.decodeMenuConsumer);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "vatRate"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dTaxes.decodeVatRate.decode)})())({
    reflectSymbol: () => "variants"
  })(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.booleanDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "upSellingParameters"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "tags"})(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dTags.ordTag)(Restaumatic$dMenu$dV2$dTypes$dTags.decodeTag);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "productModifiers"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "price"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Data$dMoney$dRounded.decodeMoney)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "photo"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)})())({
    reflectSymbol: () => "packagingContainersConfigOverride"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainersConfig.decode)})())({
    reflectSymbol: () => "nonDivisibleModifiersOrder"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "name"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifierSettings"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(decodeModifierSettings)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeModifierSettings.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "exchangeSuggestionList"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "divisibleModifiersOrder"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "description"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "crossSellingListOverride"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)})())({
    reflectSymbol: () => "category"
  })({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())({reflectSymbol: () => "availabilitySchedule"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)
  })())({reflectSymbol: () => "availability"})({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.decodeAvailability.decode})())({reflectSymbol: () => "allergens"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.asJSONKeyAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.decodeAllergenConcentration)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAllergen.decodeAllergenConcentration.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ModifierSettings,
  Product,
  decodeModifierSettings,
  decodeProduct,
  encodeModifierSettings,
  encodeProduct,
  eqModifierSettings,
  eqProduct,
  genericModifierSettings,
  genericProduct,
  hasFieldModifierSettings,
  hasFieldProduct,
  newtypeModifierSettings_,
  newtypeProduct_,
  showModifierSettings,
  showProduct,
  unscrambleDecodeModifierSettings,
  unscrambleDecodeProduct
};
